import { baseApi } from "./baseApi";
const SMS_INTEGRATION_BASE_URL = "/sms-integrations";

export const smsIntegrationApi = baseApi.injectEndpoints({
  tagTypes: ["SmsIntegration"],

  endpoints: (build) => ({
    addSmsIntegration: build.mutation({
      query: (body) => ({
        url: SMS_INTEGRATION_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "SmsIntegration", id: "LIST" }],
    }),
    listSmsIntegrations: build.query({
      query: (params) => ({
        url: SMS_INTEGRATION_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.invalidatesTags
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "SmsIntegration",
                id: _id,
              })),
              { type: "SmsIntegration", id: "LIST" },
            ]
          : [{ type: "SmsIntegration", id: "LIST" }],
    }),
    getDDLSmsIntegrationList: build.query({
      query: (params) => ({
        url: `${SMS_INTEGRATION_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "SmsIntegration",
                id: _id,
              })),
              { type: "SmsIntegration", id: "DDL" },
            ]
          : [{ type: "SmsIntegration", id: "DDL" }],
    }),
    getSmsIntegrationDetail: build.query({
      query: (smsIntegrationId) => `${SMS_INTEGRATION_BASE_URL}/${smsIntegrationId}`,
      providesTags: (result, error, { _id }) => [
        { type: "SmsIntegration", id: _id },
        { type: "SmsIntegration", id: "LIST" },
      ],
    }),
    updateSmsIntegration: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${SMS_INTEGRATION_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "SmsIntegration", id },
        { type: "SmsIntegration", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListSmsIntegrationsQuery,
  useLazyListSmsIntegrationsQuery,
  useAddSmsIntegrationMutation,
  useLazyGetDDLSmsIntegrationListQuery,
  useGetSmsIntegrationDetailQuery,
  useUpdateSmsIntegrationMutation,
} = smsIntegrationApi;